// app/routes.ts
import { Routes } from '@angular/router';
import { PoliciesType } from './shared/constants/RoleType';
import {
  OAuthGuard,
  ORoleGuard,
  OCallbackComponent,
  ODefaultComponent,
} from '@olameter/o-authentication';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'serialized',
  },
  {
    path: 'serialized',
    canActivate: [OAuthGuard, ORoleGuard],
    data: { policies: [PoliciesType.ForRead] },
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./serialized/serialized.component').then(
        (m) => m.InventorySerializedComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'prefix',
        loadComponent: () =>
          import('./serialized/serialized-grid/serialized-grid.component').then(
            (m) => m.InventorySerializedGridComponent
          ),
      },
      {
        path: ':invId',
        pathMatch: 'full',
        loadComponent: () =>
          import('./serialized/serialized-item/serialized-item.component').then(
            (m) => m.InventorySerializedItemComponent
          ),
      }
    ],
  },

  {
    path: 'non-serialized',
    canActivate: [OAuthGuard, ORoleGuard],
    data: { policies: [PoliciesType.ForRead] },
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./non-serialized/non-serialized.component').then(
        (m) => m.InventoryNonSerializedPage
      ),
    children: [
      {
        path: '',
        pathMatch: 'prefix',
        loadComponent: () =>
          import('./non-serialized/non-serialized-grid/non-serialized-grid.component').then(
            (m) => m.InventoryNonSerializedGrid
          ),
      },
      {
        path: ':invId',
        loadComponent: () =>
          import('./non-serialized/non-serialized-item/non-serialized-item.component').then(
            (m) => m.InventoryNonSerializedItemComponent
          ),
      }
    ],
  },
  {
    path: 'locations',
    canActivate: [OAuthGuard, ORoleGuard],
    data: { policies: [PoliciesType.ForRead] },
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./locations/locations.component').then(
        (m) => m.InventoryLocationsPage
      ),
  },
  {
    path: 'callback',
    component: OCallbackComponent,
  },
  {
    path: '**',
    component: ODefaultComponent,
  },
];
